import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Background from '../../../components/Background/Background';
import Highlight from '../../../components/Highlight/Highlight';
import classes from './Output.styles.less';
export default function Output({ data }) {
    if (data.loading) {
        return (_jsx(Background, { className: classes.wrapper, children: "Processing with svgo \u2192 svg2jsx \u2192 prettier" }));
    }
    if (data.content) {
        return (_jsx(Background, { className: classes.wrapper, children: _jsx(Highlight, { children: data.content }) }));
    }
    return null;
}
